import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, Mail, Lock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function GoogleButton() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button onClick={handleGoogle} data-testid="google-login-btn"
      className="w-full flex items-center justify-center gap-3 bg-white font-bold px-5 py-3.5 rounded-xl border-2 border-ink neo-press">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
      Continue with Google
    </button>
  );
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="grid place-items-center w-12 h-12 bg-brand-yellow neo rounded-xl mx-auto mb-4"><Sparkles className="w-6 h-6" /></span>
          <h1 className="font-display font-bold text-4xl">Welcome back</h1>
          <p className="font-semibold text-ink/70 mt-1">Sign in to your FabricATE account.</p>
        </div>
        <div className="bg-white neo-lg rounded-3xl p-7">
          <GoogleButton />
          <div className="flex items-center gap-3 my-6"><div className="flex-1 border-t-2 border-ink" /><span className="text-xs font-bold uppercase text-ink/50">or</span><div className="flex-1 border-t-2 border-ink" /></div>
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="bg-brand-pink border-2 border-ink rounded-lg p-3 text-sm font-bold" data-testid="login-error">{error}</div>}
            <div className="flex items-center gap-2 border-2 border-ink rounded-xl px-3">
              <Mail className="w-4 h-4 shrink-0" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email"
                className="w-full py-3 outline-none font-semibold bg-transparent" />
            </div>
            <div className="flex items-center gap-2 border-2 border-ink rounded-xl px-3">
              <Lock className="w-4 h-4 shrink-0" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password"
                className="w-full py-3 outline-none font-semibold bg-transparent" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-ink text-paper font-bold px-6 py-3.5 rounded-xl neo-press border-2 border-ink disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="text-center font-semibold text-ink/70 mt-5">
            New here? <Link to="/register" className="font-bold underline" data-testid="to-register">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
